export const TUTORIAL_DATA = [
  {
    description: '루틴 생성하기',
    imageSrc: '/images/tutorial/create-routine.webp',
  },
  {
    description: '운동 순서 변경',
    imageSrc: '/images/tutorial/workout-reorder.webp',
  },
  {
    description: '운동 편집',
    imageSrc: '/images/tutorial/manage-workout.webp',
  },
  {
    description: '루틴 플레이',
    imageSrc: '/images/tutorial/routine-play.webp',
  },
];
